// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__GMKLI","social_list":"Footer_social_list__BZTrs","copy_right":"Footer_copy_right__dVbzA"};